module.exports = __webpack_public_path__ + "img/credit6.3977c59d.png";